import useCan from '@/composables/useCan'
import useGalvanickAppliances from '@/composables/useGalvanickAppliances'
import { computed, type ComputedRef } from 'vue'

const pollingMS = 60000

/**
 * Whether the Deployment page is showing a warning: an appliance without a VRF,
 * counted only for callers the page would show it to.
 */
const useDeploymentWarning = (): ComputedRef<boolean> => {
  const canManageAppliances = useCan('manageAppliances')

  const { data: appliances } = useGalvanickAppliances({ enabled: canManageAppliances, refetchInterval: pollingMS })

  return computed(
    () =>
      canManageAppliances.value &&
      !!appliances.value?.results?.some((a) => !a.vrf_id),
  )
}

export default useDeploymentWarning
